<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>{{label()}}</mat-panel-title>
  </mat-expansion-panel-header>
  <mat-tree #tree [dataSource]="dataSource()" [childrenAccessor]="childrenAccessor">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="12">
      <mat-checkbox
        [checked]="node.completed"
        [indeterminate]="partiallyComplete(node)"
        (change)="updateNode($event.checked, node)"
      >
        <small>{{nodeLabel(node)}}</small>
      </mat-checkbox>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding
      matTreeNodeToggle
      [matTreeNodePaddingIndent]="12"
      [cdkTreeNodeTypeaheadLabel]="node.label">
      <div class="node-content">
        <mat-checkbox
          [checked]="node.completed"
          [indeterminate]="partiallyComplete(node)"
          (change)="updateNode($event.checked, node)"
          (click)="$event.stopPropagation()"
        >
        </mat-checkbox>
        <small>{{nodeLabel(node)}}</small>
        <button matTreeNodeToggle>
          @if (tree.isExpanded(node)) {
            <mat-icon>expand_less</mat-icon>
          } @else {
            <mat-icon>expand_more</mat-icon>
          }
        </button>
      </div>
    </mat-tree-node>
  </mat-tree>
</mat-expansion-panel>
